<!-- @veltra/icons generated sha256:87c9b681c36e1a38 gen:8 source:src/svg/normal/setting.svg -->
<script setup lang="ts">
defineOptions({ name: 'Setting' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="m13.544 4.336-5.065-2.82a.97.97 0 0 0-.958 0l-5.064 2.82a.99.99 0 0 0-.519.866v5.596c0 .362.201.69.519.866l5.064 2.82a.97.97 0 0 0 .958 0l5.065-2.82a.99.99 0 0 0 .518-.866V5.202a.99.99 0 0 0-.518-.866M2.938 10.787V5.213L8 2.395l5.062 2.818v5.574L8 13.605zM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-5a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
    />
  </svg>
</template>
